// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export interface Step {
    /** Step Name */
    name: string;
    /** Step Name */
    displayName?: string;
    /** Step index */
    index: number;
    /** Step Next */
    next?: number;
    /** Step Prev */
    prev: number;
    /** Page Step */
    url?: string;
}

export const findStep = (steps: Step[], currentStep: number) => {
    return steps.find(item => item.index === currentStep) || steps[0] || {};
};

export const nextStepHandler = (steps: Step[], currentStep: number) => {
    const next = findStep(steps, currentStep).next;
    return findStep(steps, next || 1);
};

export const previousStepHandler = (steps: Step[], currentStep: number) => {
    const prev = findStep(steps, currentStep).prev;
    return findStep(steps, prev);
};

type CallBackSome<T> = (value: T, index?: number, collection?: T[]) => Promise<boolean>;

export async function some<T>(elements: T[], cb: CallBackSome<T>): Promise<boolean> {
    for (const [index, element] of elements.entries()) {
        if (await cb(element, index, elements)) {
            return true;
        }
    }
    return false;
}
